import { Component, Vue } from 'vue-property-decorator';
@Component({ name: 'MembersOnly' })
export default class extends Vue {
    t;
}
